import styled from 'styled-components';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getCurrentEnterpriseReservationGroupIdsByAvailabilityBlockId } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { EditDialogForm } from '@mews-commander/legacy-form';
import { showReservationGroupDetail } from '../../actions/availabilityBlock';

interface ChangeAvailabilityBlockStateBlockedDialogProps {
    onClose: () => void;
    reservationsCount: number;
    availabilityBlockId: string;
}

export const ChangeAvailabilityBlockStateBlockedDialog: React.FC<ChangeAvailabilityBlockStateBlockedDialogProps> = ({
    onClose,
    reservationsCount,
    availabilityBlockId,
}) => {
    const dispatch = useCommanderThunkDispatch();
    const groupIds = useCommanderSelector((state) =>
        getCurrentEnterpriseReservationGroupIdsByAvailabilityBlockId(state, { availabilityBlockId })
    );

    const onShowReservationClick = () => {
        dispatch(showReservationGroupDetail({ groupId: groupIds[0] }));
        onClose();
    };

    return (
        <EditDialogForm
            active
            loading={false}
            secondaryButtonTextKey={TextKey.GoBack}
            primaryButtonTextKey={TextKey.ShowReservations}
            title={<LocalizedText textKey={TextKey.ToChangeAvailabilityBlockStateCancelReservationTitle} />}
            closeDialog={onClose}
            handleSubmit={onShowReservationClick}
        >
            <BodyWrapper>
                <LocalizedText
                    textKey={TextKey.ToChangeAvailabilityBlockStateCancelReservation}
                    substitutes={{ count: reservationsCount }}
                />
            </BodyWrapper>
        </EditDialogForm>
    );
};

const BodyWrapper = styled.div`
    display: inline;
`;
